import { useContext } from 'react';

import { WatermarkActionContext, WatermarkValueContext } from './context';

const useWatermarkValue = () => {
  const context = useContext(WatermarkValueContext);
  if (!context) {
    throw new Error(
      'useWatermarkValue must be used within a <WatermarkFormContext />',
    );
  }
  return context;
};

const useWatermarkAction = () => {
  const context = useContext(WatermarkActionContext);
  if (!context) {
    throw new Error(
      'useWatermarkAction must be used within a <WatermarkFormContext />',
    );
  }
  return context;
};

export { useWatermarkAction, useWatermarkValue };
